import { CarRentalState } from './index';
import { ActionTree } from 'vuex';
import { IStore } from "@store/index";
import { AxiosError, AxiosResponse } from "axios";
import { CarRental, Vehicle } from "../interfaces/carRental";
import { CarExtra } from "../interfaces/carExtra";
import { AvailableCarExtra } from "../interfaces/availableCarExtra";
import CheckoutItem from "../interfaces/checkoutItem";
import { postResponse } from "@store/services/fetchCheckoutData";

export default {
    async getAvailableCarRentals({ commit, dispatch, rootState }) {
        await postResponse(
            rootState.checkout.apiEndpoint,
            'GetCarRentals',
            rootState.checkout.apiToken,
            {
                'tripUid': rootState.checkout.checkoutSummary.tripId,
                'appointmentId': rootState.checkout.checkoutSummary.appointmentId,
                'chosenRooms': rootState.checkout.checkoutSummary.rooms,
                'fare': rootState.checkout.checkoutSummary.fare,
                'sessionId': rootState.checkout.checkoutSettings.sessionId
            },
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('setAvailableCarRentals', response.data);
                dispatch('setInitialCarRentals')
            })
            .catch((e: AxiosError) => {
                const responseStatus = e.response ? e.response.status : 'none';
                const message = `Error in getAvailableCarRentals | Error code: 1642576706249 | HTTP status: ${responseStatus} | ${e.message}`;

                dispatch('openErrorOverlay');

                throw Error(message);
            });
    },
    setInitialCarRentals({ commit, dispatch, getters, rootGetters }) {
        const availableCars: CarRental[] = getters.getAvailableCarRentals;
        const availableExtras: AvailableCarExtra[] = getters.getAvailableCarExtras;
        const currentCars: CheckoutItem[] = rootGetters['checkout/getCarRentals'];
        const days: any = {};
        const chosenExtras: CarExtra[] = [];

        availableCars.forEach((day) => {
            const dayKey: string = day.dayRange.replace(/\s/g, '');
            let chosenCarRentals: Vehicle | undefined;

            day.vehicles.forEach((car) => {
                if (currentCars.find(acc => acc.id === car.id)) {
                    chosenCarRentals = car;
                }
            })

            if (!chosenCarRentals) {
                chosenCarRentals = day.vehicles.find(carRental => carRental.calculationStatus === 'STANDARD');
            }

            days[dayKey] = { ...chosenCarRentals, dayRange: day.dayRange };
        })

        availableExtras.forEach((extra) => {
            const currentExtra = currentCars.find(acc => acc.id === extra.id);
            if (currentExtra) {
                const extraItem = { ...extra, amount: currentExtra.amount }
                chosenExtras.push(extraItem);
            }
        })

        commit('initCarRentals', [days, chosenExtras]);

        dispatch('funnel/addSelectedToCheckoutFunnel', { type: 'carRentals', picked: days }, { root: true });
        dispatch('funnel/addSelectedToCheckoutFunnel', { type: 'carExtras', picked: chosenExtras }, { root: true });
    },

    updateCarRentals({ commit, dispatch, getters }, [carId, currentDay]) {
        const dayKey: string = currentDay.replace(/\s/g, '');
        const availableCarRentals: CarRental[] = getters.getAvailableCarRentals;
        const carRental: CarRental = availableCarRentals.filter(day => day.dayRange === currentDay)[0];
        const filteredVehicle: Vehicle[] = carRental.vehicles.filter(vehicle => vehicle.id === carId);
        const chosenCar: Vehicle = filteredVehicle[0];

        commit('setCarRentals', [dayKey, { ...chosenCar, dayRange: currentDay }]);
        dispatch('mapCarItems');
    },

    increaseCarRentalAmount({ commit, dispatch, getters }, carExtra) {
        commit('increaseCarExtrasAmount', carExtra);
        dispatch('mapCarItems')
    },

    decreaseCarRentalAmount({ commit, dispatch, getters }, carExtra) {
        commit('decreaseCarExtrasAmount', carExtra);
        dispatch('mapCarItems')
    },

    mapCarItems({ commit, dispatch, getters }) {
        const carRentals: CheckoutItem[] = [];
        const currentCarRental = getters.getChosenCarRentals;
        const currentCarExtras: CarExtra[] = getters.getCarExtras;

        // @ts-ignore
        Object.values(currentCarRental).forEach((item: Vehicle) => {
            if (item.calculationStatus !== 'STANDARD') {
                const checkoutSummaryCarRentals: CheckoutItem = {
                    id: item.id,
                    amount: 1
                }
                carRentals.push(checkoutSummaryCarRentals);
            }
        })

        currentCarExtras.forEach(extra => {
            const CheckoutSummaryCarExtra: CheckoutItem = {
                id: extra.id,
                amount: extra.amount
            }
            carRentals.push(CheckoutSummaryCarExtra);
        })

        commit('checkout/mapCarRentalsToCheckoutSummary', carRentals, { root: true });
        dispatch('updatePriceSummary');
    },
} as ActionTree<CarRentalState, IStore>
